import React from "react";
import { Navigate } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { AccountSecurity } from "@/components/AccountSecurity";
import { usePrefs } from "@/contexts/PrefsContext";
import { useAuth } from "@/contexts/AuthContext";

export default function ChangePasswordRequired() {
  const { t } = usePrefs();
  const { user } = useAuth();
  if (user && !user.temp_password) return <Navigate to="/app" replace />;
  return (
    <AuthLayout title={t("cl.forceTitle")} sub={t("cl.forceSub")}>
      <div data-testid="force-password-change"><AccountSecurity /></div>
    </AuthLayout>
  );
}
